module.exports = __webpack_public_path__ + "e2a370020866a55fedec8e3a0ef3b2b5.fbx";